// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: true,
  appVersionAddon: '',
  webappName: 'Milieu Klachten Applicatie Behandelaar',
  api_endpoint: 'https://api.milieuklachtencentrale.nl/',
  latitude: 51.55,
  longitude: 5.083333,
  pusher: {
    broadcaster: 'pusher',
    key: '2d39bb78cd8a510d601b',
    cluster: 'eu',
    forceTLS: true,
  },
  sentry: 'https://facdc0e88c3f9ea72ae93d0d0d695a72@o4507735602298880.ingest.de.sentry.io/4507748303503440',
};
